export default __webpack_public_path__ + "static/media/envelope-simple-black.274a05de.svg";